const no_jurisdiction = [{
  path: '/login',
  component: () => import('@/views/login/login')
}]

export default no_jurisdiction